import { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { useMeasure, useMedia, useLockBodyScroll } from 'react-use'
import cn from 'classnames'
import Headroom from 'react-headroom'
import { Media } from 'gatsby-plugin-fresnel'
// import { useLocation } from '@reach/router'

import { useStyles } from './styles'
import { Text, Svg } from 'components/atoms'
import { ROUTES } from 'utils/constants'
// import { StoreContext } from 'context'

export const Header = () => {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)
  const [mobileStyles, setMobileStyles] = useState(false)

  const [ref, { width, height }] = useMeasure()
  const breakPoint = (width * 1.2) / 0.88
  const isBroken = useMedia(`(max-width: ${breakPoint}px)`)
  const isMobile = useMedia(`(max-width: 599px)`)
  const showNav = height < 90 || !isBroken
  // const location = useLocation()
  // const rootPath = location.pathname.split('/')[1]
  // const showCart =
  //   rootPath === 'product' || rootPath === 'cart' || rootPath === 'shop'
  const navContainerClasses = cn({
    [classes.navContainer]: true,
    [classes.heightBroke]: mobileStyles,
  })

  // const {
  //   store: { checkout },
  // } = useContext(StoreContext)

  // const hasItemsInCart = checkout.lineItems.length > 0

  // const cartItemCount = checkout.lineItems
  //   .map((i) => i.quantity)
  //   .reduce((a, b) => a + b, 0)

  // dynamic nav renderer, leaving in the event we move away from a static navigation

  // const data = useStaticQuery(headerQuery)
  // const layout = data.sanityHeader.pageLayout

  // const navMap = layout.map((item, i) => {
  //   const isNavNameEmpty = isNilOrEmpty(item.urlSlug)
  //   const link = isNavNameEmpty ? '' : item.urlSlug
  //   const linkClasses = cn({
  //     [classes.headerLink]: true,
  //     [classes.sideNavLink]: mobileStyles,
  //     // [classes.button]: item.navigationAppearance,
  //     // [classes.buttonMobile]: item.navigationAppearance && mobileStyles,
  //   })
  //   return (
  //     !isNilOrEmpty(item.navigationName) && (
  //       <Link to={`/${link}`} key={i} className={linkClasses}>
  //         <Text size={mobileStyles ? 'header4' : 'header3'}>
  //           {item.navigationName}
  //         </Text>
  //       </Link>
  //     )
  //   )
  // })

  const handleClick = () => setIsOpen(!isOpen)
  useLockBodyScroll(isOpen)
  useEffect(() => {
    if (!showNav) {
      setIsOpen(false)
    }
  }, [showNav])

  useEffect(() => {
    setMobileStyles(isMobile)
  }, [isMobile])

  const menuButtonClasses = cn({
    [classes.menuButton]: true,
    [classes.menuButtonOpen]: isOpen,
  })
  const linesClasses = cn({
    [classes.lines]: true,
    [classes.linesOpen]: isOpen,
  })
  const sideNavClasses = cn({
    [classes.sideNav]: true,
    [classes.sideNavOpen]: isOpen,
  })
  const linkClasses = cn({
    [classes.headerLink]: true,
    [classes.sideNavLink]: mobileStyles,
  })

  return (
    <Headroom className={classes.headroom}>
      <header className={classes.headerWrapper}>
        <div className={classes.headerContainer}>
          <div className={classes.logoContainer}>
            <Link to={ROUTES.HOME}>
              <Svg name="simple-logo-solid" />
              <span className={classes.hiddenText}>Roadcast Logo</span>
            </Link>
          </div>

          <Media greaterThanOrEqual="tablet">
            <div className={navContainerClasses} ref={ref}>
              <Link to={`/watch`} className={linkClasses}>
                <Text size={mobileStyles ? 'header4' : 'header3'}>Watch</Text>
              </Link>
              {/* <Link to={`/shop`} className={linkClasses}>
                <Text size={mobileStyles ? 'header4' : 'header3'}>Shop</Text>
              </Link> */}
              <Link to={`/partner`} className={linkClasses}>
                <Text size={mobileStyles ? 'header4' : 'header3'}>Partner</Text>
              </Link>
              <Link to={`/contact`} className={linkClasses}>
                <Text size={mobileStyles ? 'header4' : 'header3'}>Contact</Text>
              </Link>
              {/* {showCart && (
                <div className={classes.cart}>
                  <Link to={ROUTES.CART} className={classes.cartLink}>
                    <span className={classes.hiddenText}>Cart</span>

                    {hasItemsInCart && (
                      <div className={classes.cartAmount}>{cartItemCount}</div>
                    )}
                    <Svg name="cart" />
                  </Link>
                </div>
              )} */}
            </div>
          </Media>
          <Media lessThan="tablet">
            <nav>
              <>
                <button onClick={handleClick} className={menuButtonClasses}>
                  <div className={linesClasses} />
                </button>
                <div className={sideNavClasses}>
                  {/* {showCart && (
                    <div className={classes.cart}>
                      <Link to={ROUTES.CART} className={classes.cartLink}>
                        <span className={classes.hiddenText}>Cart</span>
                        {hasItemsInCart && (
                          <div className={classes.cartAmount}>
                            {cartItemCount}
                          </div>
                        )}
                        <Svg name="cart" />
                      </Link>
                    </div>
                  )} */}
                  <div className={classes.mobileLinksWrapper}>
                    <Link to={`/watch`} className={linkClasses}>
                      <Text size={mobileStyles ? 'header4' : 'header3'}>
                        Watch
                      </Text>
                    </Link>
                    {/* <Link to={`/shop`} className={linkClasses}>
                      <Text size={mobileStyles ? 'header4' : 'header3'}>
                        Shop
                      </Text>
                    </Link> */}
                    <Link to={`/partner`} className={linkClasses}>
                      <Text size={mobileStyles ? 'header4' : 'header3'}>
                        Partner
                      </Text>
                    </Link>
                    <Link to={`/contact`} className={linkClasses}>
                      <Text size={mobileStyles ? 'header4' : 'header3'}>
                        Contact
                      </Text>
                    </Link>
                  </div>
                </div>
              </>
            </nav>
          </Media>
        </div>
      </header>
    </Headroom>
  )
}

// const headerQuery = graphql`
//   query {
//     sanityHeader {
//       pageLayout {
//         navigationName
//         urlSlug
//       }
//     }
//     desktopLogo: file(relativePath: { eq: "riffLogo.png" }) {
//       childImageSharp {
//         gatsbyImageData(layout: FULL_WIDTH, quality: 100, placeholder: NONE)
//       }
//     }
//     tabletLogo: file(relativePath: { eq: "favicon-512x512.jpg" }) {
//       childImageSharp {
//         gatsbyImageData(layout: FULL_WIDTH, quality: 100, placeholder: NONE)
//       }
//     }
//   }
// `
